import React from 'react';

import {Box, Paper, Stack, Typography} from 'views/components';
import {CalendarTodayOutlined, Search, HeadsetMicOutlined, TrackChanges} from 'views/icons';
import {Translate, translate} from 'views/module';

const HowWorksCard = () => {
  const careSteps = [
    {
      icon: CalendarTodayOutlined,
      title: translate('startstep.HowWorksCard.StepSetRecurringScheduleTitle'),
      description: translate('startstep.HowWorksCard.StepSetRecurringScheduleDescription'),
    },
    {
      icon: Search,
      title: translate('startstep.HowWorksCard.StepIdentifyCareNeedsTitle'),
      description: translate('startstep.HowWorksCard.StepIdentifyCareNeedsDescription'),
    },
    {
      icon: TrackChanges,
      title: translate('startstep.HowWorksCard.StepPerfectMatchTitle'),
      description: translate('startstep.HowWorksCard.StepPerfectMatchDescription'),
    },
    {
      icon: HeadsetMicOutlined,
      title: translate('startstep.HowWorksCard.StepOngoingSupportTitle'),
      description: translate('startstep.HowWorksCard.StepOngoingSupportDescription'),
    },
  ];

  return (
    <Paper sx={{padding: {xs: '32px', sm: '32px'}, borderRadius: '24px', boxShadow: 'none'}}>
      <Stack sx={{gap: '32px'}}>
        <Stack sx={{gap: '12px'}}>
          <Typography sx={{fontSize: '24px', fontWeight: 300, color: '#2D2925', lineHeight: '128%', fontFamily: '"Spectral", serif'}}>
            <Translate expression={'startstep.HowWorksCard.Title'} />
          </Typography>
          <Typography sx={{fontSize: '16px', fontWeight: 400, color: '#2D2925A3', lineHeight: '150%'}}>
            <Translate expression={'startstep.HowWorksCard.DescriptionBeforeHighlight'} />{' '}
            <span style={{fontWeight: 600, color: '#2D2925'}}><Translate expression={'startstep.HowWorksCard.DescriptionHighlight'} /></span>{' '}
            <Translate expression={'startstep.HowWorksCard.DescriptionAfterHighlight'} />
          </Typography>
        </Stack>

        <Stack sx={{gap: '16px'}}>
          {
            careSteps.map((step) => {
              const Icon = step.icon;
              return (
                <Box
                  key={step.title}
                  sx={{
                    display: 'flex',
                    gap: '20px',
                    alignItems: 'flex-start',
                    padding: '24px 24px',
                    borderRadius: '24px',
                    backgroundColor: '#F6F2EF',
                  }}
                >
                  <Box
                    sx={{
                      width: '52px',
                      height: '52px',
                      minWidth: '52px',
                      minHeight: '52px',
                      borderRadius: '32px',
                      padding: '14px',
                      gap: '4px',
                      backgroundColor: 'white',
                    }}
                  >
                    <Icon sx={{fontSize: 24, color: '#2D2925'}} />
                  </Box>
                  <Box>
                    <Typography sx={{fontSize: '20px', fontWeight: 300, color: '#2D2925', lineHeight: '128%', fontFamily: '"Spectral", serif'}}>
                      {step.title}
                    </Typography>
                    <Typography sx={{fontSize: '16px', fontWeight: 400, color: '#2D2925A3', lineHeight: '150%'}}>
                      {step.description}
                    </Typography>
                  </Box>
                </Box>
              );
            })
          }
        </Stack>

        <Stack sx={{gap: '12px'}}>
          <Typography sx={{fontSize: '24px', fontWeight: 300, color: '#2D2925', lineHeight: '128%', fontFamily: '"Spectral", serif'}}>
            <Translate expression={'startstep.HowWorksCard.MutualOptInTitle'} />
          </Typography>
          <Typography sx={{fontSize: '16px', fontWeight: 400, color: '#2D2925A3', lineHeight: '150%'}}>
            <Translate expression={'startstep.HowWorksCard.MutualOptInBeforeHighlight'} />{' '}
            <span style={{fontWeight: 600, color: '#2D2925'}}><Translate expression={'startstep.HowWorksCard.MutualOptInHighlight'} /></span>.{' '}
            <Translate expression={'startstep.HowWorksCard.MutualOptInAfterHighlight'} />
          </Typography>
        </Stack>
      </Stack>
    </Paper>
  );
};

export default React.memo(HowWorksCard);
